import React from "react";
import { Outlet, redirect } from "react-router-dom";
import { getCurrUser } from "../../Auth";

export async function loader() {
  try {
    const { position } = await getCurrUser();
    if (position === "teacher" || position === "assistant") {
      return redirect("/overview");
    } else if (position === "admin") {
      return redirect("/admin");
    } else if (position === "student") {
      return redirect("/profile");
    }
    return null;
  } catch (error) {
    return null;
  }
}

export default function Login() {
  return (
    <>
      <Outlet />
    </>
  );
}
